import { render, staticRenderFns } from "./reg.vue?vue&type=template&id=c2b700bc&scoped=true"
import script from "./reg.vue?vue&type=script&lang=js"
export * from "./reg.vue?vue&type=script&lang=js"
import style0 from "./reg.vue?vue&type=style&index=0&id=c2b700bc&prod&lang=scss&scoped=true"
import style1 from "./reg.vue?vue&type=style&index=1&id=c2b700bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b700bc",
  null
  
)

export default component.exports